import React from "react";
import classes from "./Team.module.css";
import { CardSingle } from "../../UI/Cards";
import puneet from "../../Assets/puneet.png";
import Button from "react-bootstrap/Button";

const AthwalRMT = () => {
  return (
    <div className={classes.Intro}>
      <h1 className={classes.focusLine}>
        <span>PUNEET ATHWAL RMT</span>
      </h1>
      <CardSingle>
        <div className={classes.blackcard}>
          <img
            className={classes.portrait}
            src={puneet}
            alt=""
          />
        </div>
        <div className={classes.container1}>
          <p>
            Puneet is a recent honors graduate of Bryan College as of 2021. She
            is passionate and dedicated towards the mental, physical, and
            emotional well being of all her clients and constantly striving for
            a better quality of life for each person she interacts with.
            <br />
            <br />
            Throughout her journey, Puneet has continued to follow her passion
            for helping people with her Bachelor’s degree in Sociology and was
            able to achieve exceptional social skills and experience dealing
            with individuals who are neuro divergent and many other various
            health conditions and disorders.
            <br />
            <br />
            Puneet specializes in Deep Tissue Work, Swedish Massage Techniques,
            Trigger Point Therapy, Joint Mobilizations, Relaxation Therapy which
            all help to effectively target areas of pain and discomfort. Her
            primary focus is to help client’s not only walk out feeling more
            relaxed, but also addressing concerns about overall health and
            balance. Using her techniques, Puneet is able to combat issues such
            as acute/chronic pain, stress/anxiety, joint problems,
            sprains/strains, muscle fatigue, postural conditions, infant massage
            and much more. Puneet is very committed to bringing a positive
            energy and attitude each day to not only her clients but everyone
            she surrounds herself with as well.
            <br />
            <br />
          </p>
        </div>
        <a className={classes.bookSpecial} href="https://amplifynewmarket.janeapp.com/#/staff_member/3">
          <Button
              variant="default"
          >
            BOOK WITH PUNEET
          </Button>
        </a>
      </CardSingle>
    </div>
  );
};

export default AthwalRMT;
